var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 64,
    viewBox: "0 0 57 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 32C37.4953 32 44.7857 24.8375 44.7857 16C44.7857 7.1625 37.4953 0 28.5 0C19.5047 0 12.2143 7.1625 12.2143 16C12.2143 24.8375 19.5047 32 28.5 32ZM40.6888 36.075L34.6071 60L30.5357 43L34.6071 36H22.3929L26.4643 43L22.3929 60L16.3112 36.075C7.23951 36.5 0 43.7875 0 52.8V58C0 61.3125 2.73549 64 6.10714 64H50.8929C54.2645 64 57 61.3125 57 58V52.8C57 43.7875 49.7605 36.5 40.6888 36.075Z",
    fill: "#0A064C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.675b7a98f637bea955d41d2a2648e11e.svg";
export { ForwardRef as ReactComponent };